import { ResponseWithStatus } from './response_with_status';

export class ApiClientError<
  T
> extends Error {
  public response!: ResponseWithStatus<T>;

  constructor(m: string) {
    super(m);
    Object.setPrototypeOf(this, ApiClientError.prototype);
    this.constructor = ApiClientError;
    this.message = m;
  }

  getHumanError(): string {
    if (this.response) {
      if (this.response.result && this.response.result.errors) {
        return Object.keys(this.response.result.errors)
          .map((k) => this.response.result?.errors?.[k])
          .join('\n');
      } else if (this.response.originalBody) {
        return this.response.originalBody;
      }
    }
    return `Unknown error`;
  }
}
